import { ExtraSectionIdentifiers } from '../activity-builder.apollo';
import { PresentDrawer } from './activity-builder-present.constants';
import * as Styled from './activity-builder-present-progress-bar.style';

type Props = {
  progress: number;
  total: number;
  activeSectionId: string;
  drawer: PresentDrawer;
};

const ActivityBuilderPresentProgress = ({
  progress,
  total,
  activeSectionId,
  drawer,
}: Props) => {
  const currentProgress =
    activeSectionId === ExtraSectionIdentifiers.Introduction
      ? 1
      : activeSectionId === ExtraSectionIdentifiers.Conclusion
        ? total + 2
        : progress + 2;

  const totalSteps = total + 2;
  const value = Math.floor((currentProgress / totalSteps) * 100);
  return (
    <Styled.ProgressBar
      $progress={value}
      $isDrawerActive={drawer.isActive}
      $isDrawerDetailsActive={drawer.isDetailActive}
    >
      <Styled.ProgressBarProgress />
    </Styled.ProgressBar>
  );
};

export default ActivityBuilderPresentProgress;
